import { Link } from "react-router-dom";
import { Train, ShieldCheck, Compass, Wrench, GraduationCap, Activity, Users, Headphones } from "lucide-react";

const ROLES = [
  { slug: "train-driver", title: "Train Driver", blurb: "Train operating company driver — passenger or freight.", icon: Train },
  { slug: "conductor", title: "Conductor / Train Manager", blurb: "Customer-facing safety-critical onboard role.", icon: ShieldCheck },
  { slug: "depot-driver", title: "Shunter / Depot Driver", blurb: "Move stock around the depot, couple/uncouple.", icon: Compass },
  { slug: "fitter", title: "Fitter / Maintenance", blurb: "Mechanical & electrical fault finding on rolling stock.", icon: Wrench },
  { slug: "graduate", title: "Graduate Schemes", blurb: "Network Rail, HS2, TOC graduate programmes.", icon: GraduationCap },
  { slug: "apprentice", title: "Apprenticeships", blurb: "Earn while you learn — engineering, customer service & more.", icon: Activity },
  { slug: "customer-service", title: "Customer Service", blurb: "Station, ticketing and onboard customer roles.", icon: Headphones },
  { slug: "engineering", title: "Engineering & Signalling", blurb: "Track, structures, OLE, signalling design.", icon: Users },
];

export default function Careers() {
  return (
    <div className="bg-cream min-h-screen">
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-16 pb-20">
        <div className="text-xs uppercase tracking-[0.2em] font-semibold text-ink">Role guides</div>
        <h1 className="font-display font-extrabold text-ink text-4xl md:text-6xl tracking-tight mt-2 leading-tight max-w-3xl">
          Every UK railway role, explained from the inside.
        </h1>
        <p className="text-muted-foreground mt-4 max-w-2xl">
          Independent, recruiter-grade guidance on the recruitment process, online screening, psychometrics, structured interviews and medical for safety-critical UK rail roles.
        </p>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {ROLES.map((r) => {
            const Icon = r.icon;
            return (
              <Link key={r.slug} to={`/careers/${r.slug}`} data-testid={`careers-${r.slug}`} className="group bg-card border border-border rounded-lg p-7 hover:-translate-y-1 hover:border-white hover:shadow-lg transition-all">
                <div className="w-12 h-12 rounded-md bg-sand text-ink flex items-center justify-center mb-5 group-hover:bg-amber transition-colors">
                  <Icon className="w-5 h-5" />
                </div>
                <h2 className="font-display font-bold text-ink text-2xl tracking-tight">{r.title}</h2>
                <p className="text-muted-foreground text-sm mt-2">{r.blurb}</p>
                <div className="mt-5 text-[11px] uppercase tracking-[0.15em] text-ink/60 group-hover:text-amber-600">Open guide →</div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
